// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".accordion-item {\n  display: block;\n  width: 100%;\n}\n", "",{"version":3,"sources":["accordion-item.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,WAAW;AACb","file":"accordion-item.css","sourcesContent":[".accordion-item {\n  display: block;\n  width: 100%;\n}\n"]}]);
// Exports
module.exports = exports;
